import React, { useEffect } from 'react';
import PublicHeader from '../../components/navigation/PublicHeader';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import PricingSection from './components/PricingSection';
import TrustSection from './components/TrustSection';
import ScheduleSimulation from './components/ScheduleSimulation';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <PublicHeader />
      <main>
        <HeroSection />
        <FeaturesSection />
        <ScheduleSimulation />
        <PricingSection />
        <TrustSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;